import PortalIdParser from 'PortalIdParser';
import * as React from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISection from 'UIComponents/section/UISection';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import usePropertiesWithOptions from 'flow-doctor-lib/hooks/usePropertiesWithOptions';
import { formatPropertyValue, isEmptyPropertyValue } from 'flow-doctor-lib/utils/propertyFormatters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getRawOptions = propertyValue => {
  if (propertyValue) {
    return [propertyValue && propertyValue.value];
  }
  return [];
};
const WalmartFilterPropertyEvaluationValue = ({
  evaluationData,
  objectTypeId
}) => {
  const rawOptions = React.useMemo(() => getRawOptions(evaluationData.propertyValue), [evaluationData.propertyValue]);
  const {
    propertyWrapper,
    labelsForOptions,
    loading: propertyMapLoading,
    error: propertyMapError
  } = usePropertiesWithOptions({
    portalId: PortalIdParser.get(),
    propertyName: evaluationData.propertyValue && evaluationData.propertyValue.name,
    objectTypeId,
    rawOptions
  }, {
    skipOptions: !evaluationData.propertyValue
  });
  if (isEmptyPropertyValue(evaluationData, propertyWrapper)) {
    return /*#__PURE__*/_jsx(UISection, {
      className: "m-bottom-0 m-top-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.popover.missingPropertyValue"
      })
    });
  }
  const isLoadingPropertyReferences = !propertyMapError && (propertyMapLoading || !propertyWrapper);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isLoadingPropertyReferences ? /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.valueWhenEnrolled",
      options: {
        value: formatPropertyValue(labelsForOptions[evaluationData.propertyValue.value] || evaluationData.propertyValue.value, propertyWrapper)
      }
    })
  });
};
export default WalmartFilterPropertyEvaluationValue;